"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../../..");

var _CalendarDay = require("../CalendarDay");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var CalendarDaysWrapper = ( /*#__PURE__*/0, _styledBase["default"])(_.Flex, {
  target: "e1ccojft0",
  label: "CalendarDaysWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1fg7h64",
  styles: "flex-wrap:wrap;margin-bottom:2px;margin-right:2px;"
} : {
  name: "1fg7h64",
  styles: "flex-wrap:wrap;margin-bottom:2px;margin-right:2px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var getCustomDateProps = function getCustomDateProps(disabledDates, interactiveDisabledDates, isInRange, day) {
  var isDisabled = disabledDates.some(function (date) {
    var a = date.toLocaleDateString();
    var b = day.date.toLocaleDateString();
    return a === b;
  });
  var props = {
    selected: day.selected || interactiveDisabledDates && day.selectable,
    highlighted: isInRange(day.date),
    selectable: day.selectable
  };

  if (isDisabled) {
    props.selectable = false;
    props.highlighted = false;
    props.disabled = isDisabled;
    props['aria-disabled'] = isDisabled && interactiveDisabledDates;
  }

  return props;
};

var CalendarDays = function CalendarDays(_ref) {
  var weeks = _ref.weeks,
      month = _ref.month,
      year = _ref.year,
      getDateProps = _ref.getDateProps,
      _ref$disabledDates = _ref.disabledDates,
      disabledDates = _ref$disabledDates === void 0 ? [] : _ref$disabledDates,
      _ref$interactiveDisab = _ref.interactiveDisabledDates,
      interactiveDisabledDates = _ref$interactiveDisab === void 0 ? false : _ref$interactiveDisab,
      _ref$onMouseEnterOfDa = _ref.onMouseEnterOfDay,
      onMouseEnterOfDay = _ref$onMouseEnterOfDa === void 0 ? function () {} : _ref$onMouseEnterOfDa,
      _ref$isInRange = _ref.isInRange,
      isInRange = _ref$isInRange === void 0 ? function () {} : _ref$isInRange;
  return /*#__PURE__*/_react["default"].createElement(CalendarDaysWrapper, null, weeks.map(function (week) {
    return week.map(function (day, index) {
      if (!day) {
        return /*#__PURE__*/_react["default"].createElement(_CalendarDay.CalendarEmptyDay, {
          key: "".concat(year).concat(month).concat(index)
        }) // eslint-disable-line react/no-array-index-key
        ;
      }

      return /*#__PURE__*/_react["default"].createElement(_CalendarDay.CalendarDay, (0, _extends2["default"])({
        key: "".concat(year).concat(month).concat(index) // eslint-disable-line react/no-array-index-key

      }, getDateProps({
        dateObj: day,
        onMouseEnter: function onMouseEnter() {
          return onMouseEnterOfDay(day);
        }
      }), getCustomDateProps(disabledDates, interactiveDisabledDates, isInRange, day)), day.date.getDate());
    });
  }));
};

CalendarDays.propTypes = {
  month: _propTypes["default"].number.isRequired,
  year: _propTypes["default"].number.isRequired,
  weeks: _propTypes["default"].arrayOf(_propTypes["default"].array).isRequired,
  getDateProps: _propTypes["default"].func.isRequired,
  disabledDates: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date)),
  interactiveDisabledDates: _propTypes["default"].bool,
  onMouseEnterOfDay: _propTypes["default"].func,
  isInRange: _propTypes["default"].func
};
var _default = CalendarDays;
exports["default"] = _default;